module.exports = "/_next/static/images/undergroundConstruction-40b6cc26787809164367c194385547be.webp";